import { createClient } from "@supabase/supabase-js";
import axios from "axios";
import axiosRetry from "axios-retry";
import React, { useEffect, useState } from "react";
import { Col, Image, Nav, Row, Tab } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { Link, useNavigate } from "react-router-dom";
import pdfIcon from "../../assets/img/Vector.png";
import askIcon from "../../assets/img/askDogmatrix.png";
import defaultImage from "../../assets/img/team/team_2.webp";
import { API, api_url, generateAuthHeader } from "../../util/util";
import { ChatBot } from "../chatbot/chatbot";
import Footer from "../footer/footer";
import Score from "../score/score";
import AllAnalytics from "./analytics";
import NewsTable from "./news";
import ProductOverview from "./productOverview";
axiosRetry(axios, {
  retries: 3,
  retryDelay: axiosRetry.exponentialDelay,
});

const supabaseUrl = process.env.REACT_APP_SUPABAE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASEKEY;
const supabase = createClient(supabaseUrl, supabaseKey);

function PageDetails({ loading, setLoading, permalink }) {
  const [companyDetails, setCompanyDetails] = useState("");
  const [financial, setFinancial] = useState([]);
  const [founder, setFounder] = useState([]);
  const [keypeople, setKeypeople] = useState([]);
  const [competitors, setCompetitors] = useState([]);
  const [isLoggIn, setIsLoggedIn] = useState(false);
  const [score, setScore] = useState("");

  const fetchProductionData = async () => {
    const url = `${api_url}/companies/${permalink}`;
    try {
      const response = await axios.get(url, {
        headers: {
          "Authorization ": generateAuthHeader(),
        },
      });
      if (response.status === 200) {
        setCompanyDetails(response.data);

      } else {
        console.error("Unexpected response");
      }
    } catch (error) {
      console.error("Error fetching suggestions:", error);
    }
  };

  const handleFetchCompetitorData = async () => {
    const url = `${api_url}/${API.ENDPOINTS.competitors}?permalink=${permalink}`;
    try {
      const response = await axios.get(url, {
        headers: {
          Authorization: generateAuthHeader(),
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200) {
        setCompetitors(response.data);
      } else {
        console.error("Unexpected response");
      }
    } catch (error) {
      console.error("Error fetching suggestions:", error);
    }
  };

  const fetchFounderData = async () => {
    const founderUrl = `${api_url}/${API.ENDPOINTS.founders}?permalink=${permalink}`;
    try {
      const response = await axios.get(founderUrl, {
        headers: {
          Authorization: generateAuthHeader(),
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200) {
        setFounder(response.data);
        setLoading(false)
      } else {
        console.error("Unexpected response");
      }
    } catch (error) {
      console.error("Error fetching founder data:", error);
    }
  };

  const fetchKeypeopleData = async () => {
    const keypeopleUrl = `${api_url}/${API.ENDPOINTS.keyPeople}?permalink=${permalink}`;
    try {
      const response = await axios.get(keypeopleUrl, {
        headers: {
          Authorization: generateAuthHeader(),
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200) {
        setKeypeople(response.data);
        setLoading(false)
      } else {
        console.error("Unexpected response");
      }
    } catch (error) {
      console.error("Error fetching keypeople data:", error);
    }
  };

  const fetchFinancialData = async () => {
    const url = `${api_url}/${API.ENDPOINTS.financial}?permalink=${permalink}`;
    try {
      const response = await axios.get(url, {
        headers: {
          Authorization: generateAuthHeader(),
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200) {
        setFinancial(response.data);
      } else {
        console.error("Unexpected response");
      }
    } catch (error) {
      console.error("Error fetching suggestions:", error);
    }
  };

  useEffect(() => {
    const checkUser = async () => {
      const { data, error } = await supabase.auth.getUser();
      if (data.user === null) {
        localStorage.removeItem("login");
        localStorage.removeItem("sb-hnfcpioavnlsyqepkgxo-auth-token");
        setIsLoggedIn(false);
        navigate("/");
      } else {
        fetchProductionData();
        fetchFinancialData();
        fetchFounderData();
        fetchKeypeopleData();
        handleFetchCompetitorData();
      }
    };
    checkUser();
  }, []);

  const navigate = useNavigate();
  const isLoggedIn = localStorage.getItem("login") === "true";
  useEffect(() => {
    if (!isLoggedIn) {
      navigate("/");
    }
  }, [isLoggedIn, navigate]);

  const [activeTab, setActiveTab] = useState("tab1");
  const handleTabSelect = (tab) => {
    setActiveTab(tab);
  };

  const columns = [
    {
      name: "Announced Date",
      selector: (row) => row.announced_date,
      sortable: true,
    },
    {
      name: "Transaction Date",
      selector: (row) => row.transaction_date,
      sortable: true,
    },
    {
      name: "Number of Investors",
      selector: (row) => row.num_of_investors,
      sortable: true,
    },
    {
      name: "Money Raised",
      selector: (row) => row.money_raised,
      sortable: true,
    },
    {
      name: "Lead Investors",
      selector: (row) => row.lead_investors,
      sortable: true,
    },
  ];


  const handleScroll = (e) => {
    const bottom = e.target.scrollHeight === e.target.scrollTop + e.target.clientHeight;
    
    // if (bottom && !loadingMore) {
    //      loadMoreData();
    // }
    return bottom; 
    // if (bottom) {
    //      return true
    // }else{
    //   return false
    // }
};    


  return (
    <section>
      <div className="page-details-container">
        <div>
          <div className="details-section">
            <div className="go-back-btn-main">
              <Link to="/search-bar" className="go-back-btn">
                <Image src={pdfIcon} className="px-2" /> Export as PDF
              </Link>
            </div>
            <div className="company-details mb-4 d-flex ">
              <div className="company-details-section">
                <div className="company-header ">
                  {companyDetails && companyDetails.logo && (
                    <img
                      src={companyDetails.logo}
                      alt="Company Logo"
                      className="company-logo me-2"
                      style={{
                        maxWidth: '128px',
                        maxHeight: '128px',
                        objectFit: 'contain'
                      }}
                      onError={(e) => {
                        e.target.style.display = 'none';
                        console.log('Error loading logo');
                      }}
                    />
                  )}
                  <div className="text-section">
                    <h4 className="company-name">{companyDetails.name}</h4>
                    {companyDetails ? (
                      <>
                        <h3 className="mt-2">{companyDetails.description}</h3>
                      </>
                    ) : (
                      <div className="text-center ">
                        <div className="spinner-border  me-2" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                        <p>Data is coming soon</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <Score score={score} />
            </div>
          </div>
          <Row>
            <Col lg={12} md={12} sm={12} >
              <Nav variant="tabs" defaultActiveKey="tab1" className="d-flex justify-content-between flex-wrap">
                <div className="d-flex flex-wrap">
                  {["Product Overview", "Financials", "People", "Competitors", "News", "Technology Audit"].map((tab, index) => (
                    <Nav.Item key={index}>
                      <Nav.Link eventKey={`tab${index + 1}`} onClick={() => handleTabSelect(`tab${index + 1}`)} className="tabs">
                        {tab}
                      </Nav.Link>
                    </Nav.Item>
                  ))}
                </div>
                <div className="ask-dogmatrix">
                  <Nav.Item>
                    <Nav.Link eventKey="tab7" onClick={() => handleTabSelect("tab7")} className="tabs d-flex align-items-center">
                      <Image src={askIcon} className="mx-2" /> Ask Dogmatix
                      <div className="ai-chatbot ms-2">AI CHATBOT</div>
                    </Nav.Link>
                  </Nav.Item>
                </div>
              </Nav>

              <Tab.Content>
                <Tab.Pane eventKey="tab1">
                  {activeTab === "tab1" && (
                    <>
                      <div className="tab-1">
                        <h2>Product Overview</h2>
                      </div>
                      <div className="tab-contents">
                        {companyDetails ? (
                          <>
                            <div>
                              <p className="company-detail">Compant Details</p>
                            </div>
                            <span className="">
                              <b>Website :</b> <a target="_blank" href={companyDetails.website}>{new URL(companyDetails.website).hostname}</a>
                            </span>

                            <span className="">
                              <b>Linkden Url :</b> {companyDetails.linkedin_url}
                            </span>

                            <span className="">
                              <b>Public Company:</b>{" "}
                              {companyDetails.public_company}
                            </span>

                            <span className="">
                              <b>Founded:</b>{" "}
                              {companyDetails.public_company}
                            </span>

                          </>
                        ) : (
                          <div className="text-center ">
                            <div className="spinner-border  me-2" role="status">
                              <span className="visually-hidden">Loading...</span>
                            </div>
                            <p>Data is coming soon</p>
                          </div>
                        )}
                        <ProductOverview permalink={permalink} />
                      </div>
                      <Footer />

                    </>
                  )}
                </Tab.Pane>
                <Tab.Pane eventKey="tab2">
                  {activeTab === "tab2" && (
                    <>
                      <div className="tab-1">
                        <h2 className="mb-3">
                          Financials
                        </h2>
                      </div>
                      {loading ? (
                        <div className="text-center ">
                          <div className="spinner-border  me-2" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                          <p>Data is coming soon</p>
                        </div>
                      ) : financial.length === 0 ? (
                        <div className="text-center ">
                          <div className="spinner-border  me-2" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                          <p>Data is coming soon</p>
                        </div>
                      ) : (
                        <>
                          <div className="tab-contents">
                            <h6>Funding, Valuation & Revenue Information</h6>
                            <DataTable
                              columns={columns}
                              data={financial}
                              pagination
                              highlightOnHover
                              pointerOnHover
                              responsive
                            />
                          </div>
                          <Footer />
                        </>
                      )}
                    </>
                  )}
                </Tab.Pane>
                <Tab.Pane eventKey="tab3">
                  {activeTab === "tab3" && (
                    <>
                      <div className="tab-1">
                        <h2 className="">Key People</h2>
                      </div>

                      {loading ? (
                        <div className="text-center ">
                          <div className="spinner-border me-2" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                          <p>Data is coming soon</p>
                        </div>
                      ) : (
                        <Row>
                          {[...keypeople].length === 0 ? (
                            <div className="text-center">
                              <div className="spinner-border me-2" role="status">
                                <span className="visually-hidden">Loading...</span>
                              </div>
                              <p>Data is coming soon</p>
                            </div>
                          ) : (
                            keypeople.map((person, index) => {
                              const isFounder = founder.includes(person.name) ||
                                (person.job_title && person.job_title.toLowerCase().includes('founder'));

                              return (
                                <Col key={index} lg={3} md={4} sm={6} xs={12} className="mb-4">
                                  <div className="person-card">
                                    <div className="card-image d-flex justify-content-between">
                                      <img
                                        src={person.image_url || defaultImage}
                                        alt={person.name || "Default Name"}
                                      />
                                      {isFounder && (
                                        <div className="founder-div">
                                          <p>Founder</p>
                                        </div>
                                      )}
                                    </div>
                                    <div className="card-content">
                                      <h3>{person.name}</h3>
                                      <p>{person.job_title || (isFounder && "Founder")}</p>
                                    </div>
                                  </div>
                                </Col>
                              );
                            })
                          )}
                        </Row>
                      )}
                      <Footer />
                    </>
                  )}
                </Tab.Pane>
                <Tab.Pane eventKey="tab4">
                  {activeTab === "tab4" && (
                    <>
                      <div className="tab-1">
                        <h2>Top Competitors</h2>
                      </div>
                      {competitors.length === 0 ? (

                        <div className="text-center ">
                          <div className="spinner-border  me-2" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                          <p>Data is coming soon</p>
                        </div>
                      ) : (
                        <Row>
                          {competitors.map((row, index) => (
                            <Col key={index} lg={3} md={4} sm={6} xs={12} className="mb-4">
                              <div className="person-competitors-card">
                                <div className="card-image">
                                  <img
                                    src={row.logo_url ? row.logo_url : defaultImage}
                                  />
                                </div>
                                <div className="card-content">
                                  <h6>{row.company_name}</h6>
                                </div>

                                <div className="body-text-pagedetails mb-1">
                                  <p>{row.description}</p>
                                </div>

                                <div className="body-link-pagedetails">
                                  <a
                                    className="news-links"
                                    // href={(row.link.startsWith('http://') || row.link.startsWith('https://') ? '' : 'https://') + row.link}
                                    // target="_blank"
                                    // rel="noreferrer"
                                    target="_blank"
                                    href="airbnb.com"
                                  >
                                    {row.website_url}
                                  </a>
                                </div>
                              </div>
                            </Col>
                          ))}
                        </Row>
                      )}
                      <Footer />
                    </>
                  )}
                </Tab.Pane>
                <Tab.Pane eventKey="tab5">
                  {(activeTab === "tab5") && (
                    <>
                      <NewsTable title="News" handleScroll={handleScroll} />
                      <Footer />
                    </>
                  )}
                </Tab.Pane>
                <Tab.Pane eventKey="tab6">
                  {activeTab === "tab6" && (
                    <>
                      <AllAnalytics />
                      <Footer />
                    </>
                  )}
                </Tab.Pane>
                <Tab.Pane eventKey="tab7">
                  {activeTab === "tab7" && (
                    <div style={{ height: "365px", display: "grid", "align-items": "stretch" }}>
                      <ChatBot />
                    </div>
                  )}
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </Row>
        </div>
      </div>
    </section>
  );
}

export default PageDetails;